import React, {Fragment, PureComponent} from 'react';
import {Card, CardBody, CardText} from 'reactstrap';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import {generate} from '../../routes.js';

import './OurDifferences.scss';

export default class OurDifferences extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    specificDifference: PropTypes.element.isRequired,
  }

  static defaultProps = {
    className: '',
    specificDifference: null
  }

  render() {
    const cardTexts = [
      <Fragment key="cardTexts-01">
        <strong>Une capacité d’intervention pour répondre à vos besoins</strong>, même dans les bassins d’emploi
        complexes (alors que les cabinets sont liés aux contrats de travail signés)
      </Fragment>,
      <Fragment key="cardTexts-02">
        <strong>La profondeur de l’expertise proposée</strong>, là où les firmes de conseil s’appuient principalement
        sur des profils juniors ou confirmés (ou à défaut quelques pigistes /indépendants).
      </Fragment>,
      <Fragment key="cardTexts-03">
        <strong>Une compétence au juste prix</strong> de part la « mise en concurrence »  profils pigistes /
        indépendants, quand les firmes de conseil appliquent une marge subjective fonction des opportunités.
      </Fragment>
    ];

    if (this.props.specificDifference !== null) {
      cardTexts.splice(1, 0, this.props.specificDifference);
    }

    const colWidth = 12 / cardTexts.length;

    return (
      <div className={`our-differences ${this.props.className}`}>
        <section className="container text-center py-5">
          <h2 className="mb-5">Pourquoi Twineeds est différent ?</h2>
          <div className="row mb-4">
            {cardTexts.map((cardText, index) => {
              return <div className={`col-md-${colWidth} mb-2`} key={index}>
                <Card className="h-100">
                  <CardBody className="d-flex align-items-center">
                    <CardText>{cardText}</CardText>
                  </CardBody>
                </Card>
              </div>;
            })}
          </div>
          <Link className="btn btn-primary" to={generate({name: 'our-vision'})}>En savoir plus</Link>
        </section>
      </div>
    );
  }
}
